import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { show } from '@frontend/utils/dom';
import ImgixHelper from '@frontend/app/features/ImgixHelper';

export default class extends Controller {
  static targets = ['specialNumber'];
  static values = {
    articleId: Number,
  };

  connect() {
    if (CurrentUser.isAuthor()) {
      show(this.specialNumberTarget);
    }

    ImgixHelper.refresh();
  }
}
